module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.windowWidth >= 800) ? _c('div', {
    staticClass: "Footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "infoCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerAbout))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=1"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSynopsis))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=2"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerDevelop))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=3"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHonor))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=4"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTeam))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProducts))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./productSpring.html"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSpring))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./productHardware.html"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHardware))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTechnology))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=1"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEchnicalAdvantages))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=2"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProductionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=3"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerInspectionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=4"
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerWorkshopEnvironment))])])]), _vm._v(" "), _c('div', {
    staticClass: "infoCon special"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerContact))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTel))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerFax))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEmail))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerAddress))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footerInfo"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerInfo))])])]) : _c('div', {
    staticClass: "Footer"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets//images/homeView/LOGO.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "titleCon",
    on: {
      "click": function($event) {
        _vm.menuTag == 1 ? _vm.menuTag = 0 : _vm.menuTag = 1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerAbout))]), _vm._v(" "), _c('img', {
    staticClass: "arro",
    class: _vm.menuTag == 1 ? 'arroAct' : '',
    attrs: {
      "src": require("../../assets/images/homeView/arro.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.menuTag == 1) ? _c('div', {
    staticClass: "menuCon"
  }, [_c('a', {
    attrs: {
      "href": "./about.html?id=1"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSynopsis))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=2"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerDevelop))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=3"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHonor))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=4"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerTeam))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titleCon",
    on: {
      "click": function($event) {
        _vm.menuTag == 2 ? _vm.menuTag = 0 : _vm.menuTag = 2
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerProducts))]), _vm._v(" "), _c('img', {
    staticClass: "arro",
    class: _vm.menuTag == 2 ? 'arroAct' : '',
    attrs: {
      "src": require("../../assets/images/homeView/arro.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.menuTag == 2) ? _c('div', {
    staticClass: "menuCon"
  }, [_c('a', {
    attrs: {
      "href": "./productSpring.html"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerSpring))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./productHardware.html"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerHardware))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titleCon",
    on: {
      "click": function($event) {
        _vm.menuTag == 3 ? _vm.menuTag = 0 : _vm.menuTag = 3
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerTechnology))]), _vm._v(" "), _c('img', {
    staticClass: "arro",
    class: _vm.menuTag == 3 ? 'arroAct' : '',
    attrs: {
      "src": require("../../assets/images/homeView/arro.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.menuTag == 3) ? _c('div', {
    staticClass: "menuCon"
  }, [_c('a', {
    attrs: {
      "href": "./technology.html?id=1"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerEchnicalAdvantages))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=2"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerProductionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=3"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerInspectionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=4"
    }
  }, [_c('div', {
    staticClass: "menuList"
  }, [_vm._v(_vm._s(_vm.copyData.footer.footerWorkshopEnvironment))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "titleCon contact"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerContact))])]), _vm._v(" "), _c('div', {
    staticClass: "contactInfo"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerTel))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerFax))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerEmail))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "footerInfo"
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.footer.footerInfo))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-454b62ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Footer.vue
// module id = 17
// module chunks = 1 3 4 5 6 7